import { compose, hoistStatics, withState } from 'recompose';
import { translate } from 'react-i18next';
import CheckBox from './CheckBox';


const enhance = compose(
  translate('portal'),
  withState('isLoading', 'setIsLoading', false),
);

export default hoistStatics(enhance)(CheckBox);



// WEBPACK FOOTER //
// ./src/components/list/grid/checkBox/index.js